import ResponsiveImage from "../../atoms/image/ResponsiveImage";
export default function CtaSecondary({ data, className }) {
  const appMode = process.env.APP_MODE;
  const link = data?.cta?.href?.[appMode] || data?.cta?.href;
  return (
    <section className={className ? className : ``}>
      <div className="bg-white container customise-wrap has-content-left fx--ch grid--wrap br-8">
        <article className="lg:maxw-md text-left md:fx--o-1">
          <h2
            className="text-lg "
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <p className="mb-5" dangerouslySetInnerHTML={{ __html: data.desc }} />
          <a className="btn-primary lg:px-7 md:w-100" href={link}>
            <span>{data.cta.text}</span>
          </a>
        </article>
        {/* <div className="cta-img-gradient" /> */}
        <ResponsiveImage
          dpi={data.image.prefixes.dpi}
          mobile={data.image.prefixes.mobile}
          src={data.image.src}
          alt={data.image.alt}
        />
      </div>
    </section>
  );
}
